/* eslint-disable camelcase,quote-props,import/extensions */
export const DefaultLocale = 'en-US';

export const Locales = {
  'en-US': () => import('../i18n/translations/translations.en'),
  'da-DK': () => import('../i18n/translations/translations.da'),
  'de-DE': () => import('../i18n/translations/translations.de'),
  'en-AU': () => import('../i18n/translations/translations.en-AU'),
  'en-CA': () => import('../i18n/translations/translations.en-CA'),
  'en-GB': () => import('../i18n/translations/translations.en-GB'),
  'es-MX': () => import('../i18n/translations/translations.es'),
  'es-ES': () => import('../i18n/translations/translations.es'),
  'fi-FI': () => import('../i18n/translations/translations.fi'),
  'fr-FR': () => import('../i18n/translations/translations.fr'),
  'fr-CA': () => import('../i18n/translations/translations.fr-CA'),
  'fr-BE': () => import('../i18n/translations/translations.fr'),
  'it-IT': () => import('../i18n/translations/translations.it'),
  'ja-JP': () => import('../i18n/translations/ja-JP'),
  'ko-KR': () => import('../i18n/translations/ko-KR'),
  'nb-NO': () => import('../i18n/translations/translations.nb'),
  'nl-NL': () => import('../i18n/translations/translations.nl'),
  'nl-BE': () => import('../i18n/translations/translations.nl'),
  'pl-PL': () => import('../i18n/translations/translations.pl'),
  'pt-BR': () => import('../i18n/translations/pt-BR'),
  'pt-PT': () => import('../i18n/translations/translations.pt'),
  'ru-RU': () => import('../i18n/translations/ru-RU'),
  'sv-SE': () => import('../i18n/translations/translations.sv'),
  'tr-TR': () => import('../i18n/translations/tr-TR'),
  'uk-UA': () => import('../i18n/translations/uk-UA'),
  'zh-Hans': () => import('../i18n/translations/zh-Hans'),
};

export const loadMessages = async (locale = DefaultLocale) => {
  const importer = Locales[locale] || Locales[DefaultLocale];
  const mod = await importer();
  return { locale, messages: mod.default || mod };
};

export const getLocaleMessages = async (locale = DefaultLocale) => {
  const { messages } = await loadMessages(locale);
  return messages;
};

export const getMessage = async (id, locale = DefaultLocale) => {
  const messages = await getLocaleMessages(locale);
  if (messages[id]) return messages[id];
  if (locale !== DefaultLocale) {
    const defaultMessages = await getLocaleMessages(DefaultLocale);
    return defaultMessages[id] || '';
  }
  return '';
};
